import BannerProjects from '../../components/bannerProjects'
import EntregasEfetivas from '../../components/entregasEfetivas'
import Expertise from '../../components/expertise'
import { Impacto } from '../../components/impacto'
import Oportunidades from '../../components/oportunidades'
import Rodape from '../../components/rodape'

export default function Finep() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/cover-finep.png"
        bgMobile="../assets/cover-finep-mobile.png"
        title="/FINEP"
        iconSrc="../assets/icone-projectiva-nex2ai.png"
        iconAlt="Projectiva Nex2AI"
        iconText="nex"
        iconTextBold="2ai"
        descriptionBold=""
        description={
          <>
            Somos{' '}
            <strong className="font-inter-bold">
              especialistas em desenvolvimento de projetos
            </strong>{' '}
            e gestão de recursos e não poupamos esforços para que seu negócio
            aproveite ao máximo as{' '}
            <strong className="font-inter-bold">
              oportunidades de fomento.
            </strong>
          </>
        }
        footerText="VERTICAL INNOVATION | Intelligence"
        buttonText="Quero me conectar"
        buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
        brand="nex2ai"
      />
      <Oportunidades />
      <Impacto />
      <Expertise />
      <EntregasEfetivas />
      <Rodape />
    </>
  )
}
